//*** Lib */

import { createCookie, getCookie, isCookieExist, removeCookie, setCookie } from "../cookies/CookieHandler";

const authCookieName = 'MR-AuthUser';
const tokenCookieName = 'MR-Token';

export const setAuthProps = (data) => {
    const authProps = {
        cookieName: authCookieName,
        cookieValue: data,
        expirationTime: data.sessionTimeout
    }
    createCookie(authProps);
    setTokenProps(data.token);
}

export const getAuthProps = () => {
    return getCookie(authCookieName);
}

export const isAuthorized = () => {
    return isCookieExist(authCookieName);
}

export const setTokenProps = (data) => {
    const tokenProps = {
        cookieName: tokenCookieName,
        cookieValue: data
    }
    setCookie(tokenProps);
}

export const getTokenProps = () => {
    return getCookie(tokenCookieName);
}

export const signOut = () => {
    localStorage.setItem("showAdminMenu", false);
    localStorage.removeItem("SecurityPermission");
    removeCookie(authCookieName);
    removeCookie(tokenCookieName);
    window.location.href = "/login";
}

export const IsAuthorizeUser = (allowUserType) => {
    let cookie = getAuthProps();
    let roleType = cookie?.["roleId"] ? Number(cookie?.["roleId"]) : 0;
    if (allowUserType !== undefined) {
        return allowUserType.find(x => x === roleType)
    }
    return ''
}
